import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "../../actions/actions";
import { listarNotasFiscais } from "../../../services/notasFiscaisService";
import { NotasFiscaisModel } from "../../../models/notasFiscais/notasFiscaisModel";
import { BuscarNotasFiscaisModel } from "../../../models/notasFiscais/buscarNotasFiscaisModel";

export interface NotasFiscaisState {
  //buscar notas fiscais
  loading: boolean;
  busca: BuscarNotasFiscaisModel;
  list: NotasFiscaisModel[];
  entity: NotasFiscaisModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: NotasFiscaisState = {
  //buscar notas fiscais
  loading: false,
  busca: {
    idEmpresa: 0,
    idSorteio: null,
    dataInicio: null,
    dataFim: null,
    idTipoArquivoAnexo: null,
  } as BuscarNotasFiscaisModel,
  list: [],
  entity: {} as NotasFiscaisModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const notasFiscaisSlice = createSlice({
  name: "notasFiscais",
  initialState,
  reducers: {
    //buscar notas fiscais
    setBuscaNotasFiscais: (state, action) => {
      state.busca = action.payload;
    },
    setEntityNotasFiscais: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarNotasFiscais: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarNotasFiscais: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar notas fiscais
    builder.addCase(listarNotasFiscais.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarNotasFiscais.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(listarNotasFiscais.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar notas fiscais
  setBuscaNotasFiscais,
  setEntityNotasFiscais,
  //internal
  setModalCadastrarNotasFiscais,
  setModalDeletarNotasFiscais,
} = notasFiscaisSlice.actions;

export default notasFiscaisSlice.reducer;
